<template>
  <div class="app-divider" :style="{ background: color, width: width, height: height }" />
</template>

<script>
export default {
  name: 'AppDivider',
  props: {
    color: { type: String, default: 'var(--ap-border)' },
    width: { type: String, default: '1px' },
    height: { type: String, default: '100%' }
  }
}
</script>

<style scoped>
.app-divider {
  display: inline-block;
  flex-shrink: 0;
}
</style>
